import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=4814fc58"
import script from "./NewsPanel.vue?vue&type=script&lang=js"
export * from "./NewsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports